<template>
    <v-container class='user-invite-list'>
        <v-row>
            <v-col cols='12'>
                <h3 class='d-block font-weight-bold flex-grow-1 mb-4 mt-3'>کاربران دعوت شده توسط شما</h3>
                <!--todo:اینوات باید ازینحا درست کار کنه ‌ -->
                <v-alert
                        v-if='false'
                        text
                        border='left'
                        prominent
                        color='info' class='mx-auto mb-5'>
                    <v-card-text class='px-0 py-0'>
                        <div>
                          <v-icon color='info' class='ml-1'>mdi-alert-circle-outline</v-icon>
                          <span class="font-weight-bold text--primary">نکات مهم :</span>
                            <span class='text--primary'>
                            لیست کاربرانی که توسط شما به ملکبا دعوت شده اند.
                            </span>
                        </div>

                        <v-btn
                                class='mt-2'
                                name='Add_Apartment'
                                color='primary darken-2'
                                :to="{name:'AddUsers'}"
                        >
                            <v-icon>mdi-plus</v-icon>
                            <span>دعوت کاربر جدید</span>
                        </v-btn>
                    </v-card-text>
                </v-alert>
            </v-col>
        </v-row>
        <v-row v-if='!loading &&invites.length > 0'>
            <v-col cols='12'>
                <v-card>
                    <v-simple-table>
                        <template v-slot:default>
                            <tbody>
                            <tr :class="$vuetify.theme.dark ? 'blue-grey darken-4':'blue lighten-5'">
                                <th class='px-1'>
                                    <label style='white-space: nowrap'>نام کاربر</label>
                                </th>
                                <th class='px-1'>
                                    <label>تلفن همراه</label>
                                </th>
                                <th class='px-1'>
                                    <label>نوع</label>
                                </th>
                                <th class='px-1'>
                                    <label>وضعیت</label>
                                </th>
                            </tr>
                            <tr v-for='user in invites' :key='user._id' @click='selectedRow(user)'>
                                <td class='px-1'>
                                    <div>{{ user.name }}</div>
                                </td>
                                <td class='px-1'>
                                    <div>{{ user.phone }}</div>
                                </td>
                                <td class='px-1'>
                                    <div>{{ translate[user.role] }}</div>
                                </td>
                                <td class='px-1'>
                                    <div>{{ translate[user.status] }}</div>
                                </td>

                            </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-card>
            </v-col>
        </v-row>
        <v-row v-if='!loading && invites.length === 0'>
            <v-col cols='12' class='text-center'>
                <h4>تا کنون هیج فردی را دعوت نکرده اید</h4>
            </v-col>
        </v-row>
        <div v-if='loading'>
            <v-col cols='12' class='text-center'>
                <h4>لطفا صبر کنید...</h4>
            </v-col>
        </div>
        <v-dialog
                v-model='inviteDetailDialog'
                max-width='320'
                v-if='selectedItem'
        >
            <v-card>
                <v-btn
                        class="red--text"
                        text
                        @click="inviteDetailDialog = false"
                ><v-icon>mdi-close</v-icon>
                </v-btn>
                <v-simple-table>
                    <template v-slot:default>
                        <tbody class='selected-invite-item'>
                        <tr class="transparent">
                            <th class='px-3 text-left'>
                                <label class='text--disabled' style='white-space: nowrap'>نام</label>
                            </th>
                            <td class='text-right'>{{ selectedItem.name }}</td>
                        </tr>
                        <tr class="transparent">
                            <th class='px-3 text-left'><label class='text--disabled'>تلفن همراه</label></th>
                            <td class='text-right'>{{ selectedItem.phone }}</td>
                        </tr>
                        <tr class="transparent">
                            <th class='px-3 text-left'><label class='text--disabled'>نوع</label></th>
                            <td class='text-right'>{{ translate[selectedItem.role] }}</td>
                        </tr>
                        <tr class="transparent">
                            <th class='px-3 text-left'><label class='text--disabled'>وضعیت</label></th>
                            <td class='text-right'>{{ translate[selectedItem.status] }}</td>
                        </tr>
                        <tr class="transparent">
                            <th class='px-3 text-left'><label class='text--disabled'>تاریخ ثبت</label></th>
                            <td class='text-right'>{{ new Date(selectedItem.date).toLocaleDateString('fa-IR') }}</td>
                        </tr>
                        <tr class="transparent">
                            <th class='px-3 text-left'><label class='text--disabled'>مجموعه</label></th>
                            <td class='text-right' v-if='selectedItem.apartment'>{{ selectedItem.apartment.title }}</td>
                        </tr>
                        <tr class="transparent">
                            <th class='px-3 text-left'><label class='text--disabled'>اطلاعات مدیر</label></th>
                            <td class='text-right'>
                                <Manager
                                        v-if='selectedItem.apartment.manager'
                                        showPhone
                                        :manager='selectedItem.apartment.manager.user'
                                        :status='selectedItem.apartment.manager.status'
                                />
                                <p class='text--disabled mb-1' v-else>بدون مدیر</p>
                            </td>
                        </tr>
                        <tr class="transparent">
                            <th class='px-3 text-left'>
                                <label class='text--disabled'>واحد</label>
                            </th>
                            <td class='text-right' v-if='selectedItem.unit'>
                                {{ selectedItem.unit.number }}
                            </td>
                        </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
    import axios from 'axios';
    import Manager from '@/components/Manager';

    export default {
        name: 'List',
        components: {Manager},
        data() {
            return {
                inviteDetailDialog: false,
                selectedItem: {},
                translate: {
                    RESIDENT: 'مستاجر',
                    MANAGER: 'مدیر',
                    OWNER: 'مالک',
                    REGISTERED: 'ثبت نام شده',
                    INVITED: 'دعوت شده'
                },
                loading: false,
                invites: []
            };
        },
        methods: {
            selectedRow(item) {
                this.inviteDetailDialog = true;
                this.selectedItem = item;
            },
            async fetchData() {
                this.loading = true;
                await axios.get('/api/invite')
                    .then(res => {
                        this.invites = res.data.invites;
                        this.loading = false;
                    }).catch(() => {
                        this.loading = false;
                    });
            }
        },
        mounted() {
            this.fetchData();
        }

    };
</script>

<style lang='scss' scoped>

</style>